import React, { useEffect, useState, useRef, useContext } from "react";
import { getCursosData } from "./services/misCursosService";
import SeccionesCursos from "./components/SeccionesCursos/SeccionesCursos";
import SeccionCursoSeleccionado from "./components/SeccionCursoSeleccionado";
import useTokenValidation from "../../../../hooks/useTokenValidation";
import { Oval, ThreeDots } from "react-loader-spinner";
import UniversalIconPerfil from "../../../../components/UniversalIconoPerfil/UniversalIconPerfil";
import BusquedaCursos from "./components/SeccionesCursos/components/BusquedaCursos";
import { WindowSizeContext } from "../../../../context/WindowSizeContext";

export default function MisCursos({ scrollRef }) {
  const { tokenEntity, resetearToken, errores, notificacionRef } =
    useTokenValidation();
  const [vCursos, setVCursos] = useState([]);
  const [vCursosTodos, setVCursosTodos] = useState([]);
  const [vIsCargandoInfo, setVIsCargandoInfo] = useState(false);
  const [vSeccionSeleccionada, setVSeccionSeleccionada] =
    useState("TodosContinuar");
  const [vIsScrollTop, setVIsScrollTop] = useState(true);
  const { width } = useContext(WindowSizeContext);   // ⬅️  ya conoces el ancho
  const [busquedaActiva, setBusquedaActiva] = useState(false); // ⬅️ nuevo



  const [filterText, setFilterText] = useState("");

  

  const mGetCursosFetch = () => {
    getCursosData(tokenEntity.token)
      .then((response) => {
        if (response.ok) {
          return response.json();
        }

        // Manejo de diferentes tipos de errores basados en el código de estado
        switch (response.status) {
          case 400:
            console.log("Datos inválidos");
            throw new Error("ERR_VALIDATION");

          case 401:
            console.log("Acceso denegado");
            throw new Error("ERR_UNAUTHORIZED");

          case 500:
            console.log("Error al obtener categorias");
            throw new Error("ERR_SERVER");

          default:
            console.log("Error inesperado");
            throw new Error("ERR_UNKNOWN");
        }
      })
      .then((result) => {
        if (result !== undefined) {
          const cursosPorEstado =
            result["detail"]["datos"]["cursos_por_estado"];
          const proximosAVencer =
            result["detail"]["datos"]["proximos_a_vencer"];

          // Combinar todos los cursos en un solo array
          const todosLosCursos = [
            ...cursosPorEstado["Sin completar"],
            ...cursosPorEstado["Completado"],
            ...cursosPorEstado["Sin empezar"],
            ...proximosAVencer,
          ];

          // Filtrar cursos duplicados por curso_id
          const cursosUnicos = todosLosCursos.reduce((acc, curso) => {
            if (!acc.some((c) => c.curso_id === curso.curso_id)) {
              acc.push(curso);
            }
            return acc;
          }, []);

          setVCursos(result["detail"]["datos"]);
          setVCursosTodos(cursosUnicos);
        }
      })
      .catch((error) => {
        // Separar las propiedades del error
        const { message } = error;
        if (message !== "ERR_ME") {
          console.log("Error de red");
        }
      })
      .finally(() => {
        setVIsCargandoInfo(false);
      });
  };

  useEffect(() => {
    setVIsCargandoInfo(true);
    if (!tokenEntity.isValidando) {
      mGetCursosFetch();
    }
  }, [tokenEntity.isValidando]);

  useEffect(() => {
    const handleScroll = () => {
      scrollRef.current && scrollRef.current.scrollTop > 0
        ? setVIsScrollTop(false)
        : setVIsScrollTop(true);
    };

    const scrollElement = scrollRef.current;
    if (scrollElement) {
      scrollElement.addEventListener("scroll", handleScroll);
    }

    return () => {
      if (scrollElement) {
        scrollElement.removeEventListener("scroll", handleScroll);
      }
    };
  }, []);

  /**
   * Cambia la sección seleccionada.
   * @param {string} seccion - La nueva sección a seleccionar.
   */
  const mCambiarSeccion = (seccion) => {
    setVSeccionSeleccionada(seccion);
  };

  

  return (
    <>
      <div
        data-figma-id="810:15668"
        class="header-style"
        style={{
          backgroundColor: vIsScrollTop ? "transparent" : "#1d1d1d",
        }}
      >
        <p data-figma-id="810:15669" class="header-texto">
          Mis cursos
        </p>
        <div data-figma-id="810:15670" class="header-iconos">
          <i class="fi fi-rs-bell bell-1-2"></i>
          <UniversalIconPerfil />
        </div>
      </div>
      <div
        class="mis-cursos-info"
        style={vIsCargandoInfo ? { alignItems: "center" } : {}}
      >
        {vIsCargandoInfo ? (
          <Oval
            visible={true}
            height="50"
            width="50"
            color="#fff"
            secondaryColor="#f5f5f5"
            ariaLabel="oval-loading"
            wrapperStyle={{}}
            wrapperClass=""
          />
        ) : (
          <>
            <div className="info-2-menu">
              {/* ⬇️ Ocultamos los botones SOLO si:
                      1) la búsqueda está activa  y
                      2) estamos en móvil */}
              {!(busquedaActiva && width <= 479) && (
                <div className="div-block-21">
                  <div
                    className={"boton-cursos" + (vSeccionSeleccionada==="Todos"?"":"-2")}
                    onClick={() => mCambiarSeccion("Todos")}
                  >
                    <div className="mis-cursos-subtitulo-texto">Todos</div>
                  </div>
                  <div
                    className={"boton-cursos" + (vSeccionSeleccionada==="Por vencer"?"":"-2")}
                    onClick={() => mCambiarSeccion("Por vencer")}
                  >
                    <div className="mis-cursos-subtitulo-texto">Por vencer</div>
                  </div>
                  <div
                    className={"boton-cursos" + (vSeccionSeleccionada==="En progreso"?"":"-2")}
                    onClick={() => mCambiarSeccion("En progreso")}
                  >
                    <div className="mis-cursos-subtitulo-texto">En progreso</div>
                  </div>
                </div>
              )}

              {/* ⬇️ Pasamos el setter al buscador */}
              <BusquedaCursos
                setFilterText={setFilterText}
                setBusquedaActiva={setBusquedaActiva}
              />
            </div>
            {vSeccionSeleccionada === "TodosContinuar" && filterText.trim() === "" && (
              <>
                <SeccionCursoSeleccionado />
                <div class="linea-miscursos-h"></div>{" "}
              </>
            )}

            <SeccionesCursos
              vSeccionSeleccionada
              vCursosTodos={vCursosTodos}
              vCursos={vCursos}
              filterText={filterText}
            />
          </>
        )}
      </div>
    </>
  );
}
